import type { ChatMessage } from '@bosmart/types'

export function formatTime(seconds: number) {
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
}

export function shouldHideModelMessage(text: string): boolean {
  const trimmed = text.trim()
  if (!trimmed) return false

  return [
    /^record_candidate_answer/i,
    /^system_keepalive/i,
    /^system_update/i,
    /^tool(s)?\b/i,
    /^function_call\b/i,
    /^assistant\.tool/i,
    /^observe:/i,
  ].some((pattern) => pattern.test(trimmed))
}

export function modelMentionsCallEnding(text: string): boolean {
  const lower = text.toLowerCase()
  return [
    'end the call',
    'you may end the call',
    'you may proceed and end',
    'thank you for joining',
    'thank you for taking time',
  ].some((phrase) => lower.includes(phrase))
}

export function formatTranscriptionForUpload(history: ChatMessage[]): string {
  const lines = [
    'INTERVIEW TRANSCRIPTION',
    '='.repeat(50),
    `Generated: ${new Date().toISOString()}`,
    `Total Messages: ${history.length}`,
    '',
    '',
  ]

  history.forEach((message, index) => {
    const timestamp = message.timestamp
      ? new Date(message.timestamp).toLocaleString()
      : `Message ${index + 1}`

    lines.push(`[${timestamp}]`, `${message.role.toUpperCase()}:`, message.text, '')
  })

  return lines.join('\n')
}

export function buildTranscriptSegments(history: ChatMessage[]) {
  return history.map((message, index) => ({
    speakerId: message.role === 'user' ? 'user' : 'ai',
    speakerName: message.role === 'user' ? 'Candidate' : 'BO-SMART AI',
    text: message.text,
    startTime: message.timestamp || new Date().toISOString(),
    stopTime: message.timestamp || new Date().toISOString(),
    sequenceNumber: index + 1,
  }))
}
